import { l } from '@js/utils/toolbox';

/**
 * Favorite background table
 * @param {[{}]} attributes [{ property: 'property' }]
 * @returns html String
 */
export const compareTable = (favouriteSettings) => {
	return `<div class="background-table">
        <div class="colBody">
            ${favouriteSettings
                .map(setting => setting.display === 'accordion'
                    ? `<div class="colRow accordion" data-rowid="${setting.id}">
                        <span class="colRow-text">
                            <span class="icon icon-circle-plus"></span>
                            <span class="icon icon-circle-minus"></span>
                            ${setting.text}
                        </span>
                        <div class="colRow--inner">${setting.children.map(subsetting =>
                            `<div class="colRow" data-rowid="${subsetting.id}">
                                <span class="colRow-text">${subsetting.text}</span>
                                <div class="colRow--inner-item">${subsetting.children.map(child =>
                                    `<span class="colRow-text">${child.text}</span>`).join('')}
                                </div>
                            </div>`
                        ).join('')}</div>
                    </div>`
                    : `<div class="colRow" data-rowid="${setting.id}">
                        <span class="colRow-text">${setting.text}</span>
                    </div>`
                ).join('')
            }
            <div class="colRow"><span class="colRow-text">${l('showresult.result.goToTrip')}</div>
        </div>
    </div>`;
};
